<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  mounted() {
    Vue.nextTick(() => {
      let sign = 1;
      let value = 1.5;
      if (!!this.content.negative_margin) {
        sign = -1;
        if (!(typeof this.content.negative_margin === "boolean")) {
          value = this.content.negative_margin;
        }
      } else {
        if (!!this.content.positive_margin) {
          if (!(typeof this.content.positive_margin === "boolean")) {
            value = this.content.positive_margin;
          }
        }
      }
      this.$el.style.setProperty("--margin", `${sign*value}rem`);
    })
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" v-if="isContentVisibleToUser()" :class="contentType" stripe-spacer-component>
  </div>
</template>

<style lang="scss">
[stripe-spacer-component] {
  margin-top: var(--margin);
}
</style>